import { useNavigate, useSearchParams } from "react-router-dom";
import { TalentPickData } from "@tvg/ts-types/TalentPicks";

const usePlaceBetFromTalentPick = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const getSelectionsForUrl = (selections: string[][]) => {
    const urlSelections: Record<string, string> = {};
    selections.forEach((level1, index) => {
      const level2Selections: string[] = [];
      level1?.forEach((level2) => {
        level2Selections.push(level2);
      });

      urlSelections[`s${index}`] = level2Selections.join(",");
    });

    return urlSelections;
  };

  const placeTalentPickBet = (talentPick: TalentPickData) => {
    searchParams.append("wt", talentPick?.wagerType.abbreviation);

    const selections = getSelectionsForUrl(talentPick.selections);
    Object.keys(selections).forEach((key) => {
      searchParams.append(key, selections[key]);
    });
    searchParams.append("bet", talentPick?.amount);

    navigate(`${window.location.pathname}?${searchParams.toString()}`);
  };

  return {
    getSelectionsForUrl,
    placeTalentPickBet
  };
};

export default usePlaceBetFromTalentPick;
